import {
  createReportBatch,
  fetchReportBatches,
  updateReportTileGrid,
  fetchReportWSI,
  fetchReportTileGrid,
  fetchReportDiagnosis
} from "@/api/craiyon";
import { DateTime } from "luxon";
import Vue from "vue";
import {
  normalize,
  ReportDiagnosis,
  ReportWSI,
  ReportTileGrid,
  ReportBatch
} from "@/store/helper";

const MODULE = "service/";
// actions
const _CREATE_REPORTBATCH = "CREATE_REPORTBATCH";
const _LOAD_REPORTBATCHES = "LOAD_REPORTBATCHES";
const _LOAD_REPORTDIAGNOSIS = "LOAD_REPORTDIAGNOSIS";
const _UPDATE_REPORT = "UPDATE_REPORT";
const _REPORT_NEXT = "REPORT_NEXT";
const _REPORT_PREVIOUS = "REPORT_PREVIOUS";
const _ACTION_SET_CURRENT_REPORTWSI = "ACTION_SET_CURRENT_REPORTWSI";
const _ACTION_SET_CURRENT_REPORTTILEGRID = "ACTION_SET_CURRENT_REPORTTILEGRID";
const _ACTION_SET_CURRENT_REPORTDIAGNOSIS =
  "ACTION_SET_CURRENT_REPORTDIAGNOSIS";
const _ACTION_REMOVE_SUSPICIOUS = "ACTION_REMOVE_SUSPICIOUS";
const _ACTION_SET_LABEL = "ACTION_SET_LABEL";
const _ACTION_ADD_AREA = "ACTION_ADD_AREA";
const _ACTION_EDIT_AREA = "ACTION_EDIT_AREA";
const _ACTION_DELETE_AREA = "ACTION_DELETE_AREA";
const _ACTION_ADD_TILE = "ACTION_ADD_TILE";
const _ACTION_DELETE_TILE = "ACTION_DELETE_TILE";
// mutations
const _TOGGLE_LOADING = "TOGGLE_LOADING";
const _TOGGLE_LOADING_REPORTTILEGRID = "TOGGLE_LOADING_REPORTTILEGRID";
const _TOGGLE_LOADING_REPORTDIAGNOSIS = "TOGGLE_LOADING_REPORTDIAGNOSIS";
const _ADD_REPORTBATCH = "ADD_REPORTBATCH";
const _SET_LABEL = "SET_LABEL";
const _ADD_AREA = "ADD_AREA";
const _EDIT_AREA = "EDIT_AREA";
const _DELETE_AREA = "DELETE_AREA";
const _ADD_TILE = "ADD_TILE";
const _DELETE_TILE = "DELETE_TILE";
const _SET_REPORTBATCHES = "SET_REPORTBATCHES";
const _SET_CURRENT_INDEX = "SET_CURRENT_INDEX"
const _SET_CURRENT_INDEX_REPORTWSI = "SET_CURRENT_INDEX_REPORTWSI"
const _ACTION_SET_CURRENT_REPORTBATCH = "ACTION_SET_CURRENT_REPORTBATCH";
const _SET_CURRENT_REPORTBATCH = "SET_CURRENT_REPORTBATCH";
const _SET_CURRENT_REPORTWSI = "SET_CURRENT_REPORTWSI";
const _SET_CURRENT_REPORTTILEGRID = "SET_CURRENT_REPORTTILEGRID";
const _SET_CURRENT_REPORTDIAGNOSIS = "SET_CURRENT_REPORTDIAGNOSIS";
const _REMOVE_SUSPICIOUS = "REMOVE_SUSPICIOUS";
// getters
const _CURRENT_REPORTWSI = "CURRENT_REPORTWSI";
const _FIND = "FIND";
const _TOTAL = "TOTAL";
const _LIST = "LIST";
const _WSIS = "WSIS";

// actions
export const CREATE_REPORTBATCH = MODULE + _CREATE_REPORTBATCH;
export const LOAD_REPORTBATCHES = MODULE + _LOAD_REPORTBATCHES;
export const UPDATE_REPORT = MODULE + _UPDATE_REPORT;
export const ACTION_SET_CURRENT_REPORTBATCH =
  MODULE + _ACTION_SET_CURRENT_REPORTBATCH;
export const ACTION_SET_CURRENT_REPORTWSI =
  MODULE + _ACTION_SET_CURRENT_REPORTWSI;
export const ACTION_SET_CURRENT_REPORTTILEGRID =
  MODULE + _ACTION_SET_CURRENT_REPORTTILEGRID;
export const ACTION_SET_CURRENT_REPORTDIAGNOSIS =
  MODULE + _ACTION_SET_CURRENT_REPORTDIAGNOSIS;
export const ACTION_SET_LABEL = MODULE + _ACTION_SET_LABEL;
export const ACTION_ADD_AREA = MODULE + _ACTION_ADD_AREA;
export const ACTION_EDIT_AREA = MODULE + _ACTION_EDIT_AREA;
export const ACTION_REMOVE_SUSPICIOUS = MODULE + _ACTION_REMOVE_SUSPICIOUS;
export const ACTION_DELETE_AREA = MODULE + _ACTION_DELETE_AREA;
export const ACTION_ADD_TILE = MODULE + _ACTION_ADD_TILE;
export const ACTION_DELETE_TILE = MODULE + _ACTION_DELETE_TILE;
export const LOAD_REPORTDIAGNOSIS = MODULE + _LOAD_REPORTDIAGNOSIS;
// mutations
export const TOGGLE_LOADING = MODULE + _TOGGLE_LOADING;
export const TOGGLE_LOADING_REPORTTILEGRID =
  MODULE + _TOGGLE_LOADING_REPORTTILEGRID;
export const TOGGLE_LOADING_REPORTDIAGNOSIS =
  MODULE + _TOGGLE_LOADING_REPORTDIAGNOSIS;
export const ADD_REPORTBATCH = MODULE + _ADD_REPORTBATCH;
export const SET_LABEL = MODULE + _SET_LABEL;
export const ADD_AREA = MODULE + _ADD_AREA;
export const EDIT_AREA = MODULE + _EDIT_AREA;
export const DELETE_AREA = MODULE + _DELETE_AREA;
export const ADD_TILE = MODULE + _ADD_TILE;
export const DELETE_TILE = MODULE + _DELETE_TILE;
export const SET_REPORTBATCHES = MODULE + _SET_REPORTBATCHES;
export const SET_CURRENT_INDEX = MODULE + _SET_CURRENT_INDEX;
export const SET_CURRENT_INDEX_REPORTWSI = MODULE + _SET_CURRENT_INDEX_REPORTWSI;
export const SET_CURRENT_REPORTBATCH = MODULE + _SET_CURRENT_REPORTBATCH;
export const SET_CURRENT_REPORTWSI = MODULE + _SET_CURRENT_REPORTWSI;
export const SET_CURRENT_REPORTTILEGRID = MODULE + _SET_CURRENT_REPORTTILEGRID;
export const SET_CURRENT_REPORTDIAGNOSIS =
  MODULE + _SET_CURRENT_REPORTDIAGNOSIS;
export const REMOVE_SUSPICIOUS = MODULE + _REMOVE_SUSPICIOUS;
export const REPORT_NEXT = MODULE + _REPORT_NEXT;
export const REPORT_PREVIOUS = MODULE + _REPORT_PREVIOUS;
// getters
export const CURRENT_REPORTWSI= MODULE + _CURRENT_REPORTWSI;
export const FIND = MODULE + _FIND;
export const TOTAL = MODULE + _TOTAL;
export const LIST = MODULE + _LIST;
export const WSIS = MODULE + _WSIS;

const state = {
  byId: {},
  allIds: undefined,
  byIdReportWSI: {},
  allIdsReportWSI: undefined,
  reportBatches: null,
  currentIndex: -1,
  currentIndexReportWSI: -1,
  currentReportBatch: null,
  currentReportWSI: null,
  currentReportTileGrid: null,
  currentReportDiagnosis: null,
  loadingReportTileGrid: false,
  loadingReportDiagnosis: false,
  cached: false
};

const getters = {
  [_CURRENT_REPORTWSI](state) {
    const id = state.allIdsReportWSI[state.currentIndexReportWSI]
    return state.byIdReportWSI[id];
  },
  [_TOTAL](state) {
    if (!state.reportBatches) return 0;
    return state.reportBatches.count;
  },
  [_FIND](state) {
    return id => {
      return state.byId[id];
    };
  },
  [_LIST](state, getters) {
    if (state.allIds === undefined) return undefined;
    return state.allIds.map(id => getters[_FIND](id));
  },
  [_WSIS](state, getters) {
    if (state.allIds === undefined) return undefined;
    return state.allIds
      .map(id => getters[_FIND](id))
      .map(reportBatch => {
        return reportBatch.reportwsis;
      })
      .flat();
  }
};

const mutations = {
  [_SET_CURRENT_INDEX](state, index) {
    state.currentIndex = index;
  },
  [_SET_CURRENT_INDEX_REPORTWSI](state, index) {
    state.currentIndexReportWSI = index;
  },
  [_SET_REPORTBATCHES](state, { reportBatches }) {
    state.reportBatches = reportBatches;
  },
  [_ADD_REPORTBATCH](state, { reportBatch }) {
    state.reportBatches.results.push(reportBatch);
  },
  [_SET_LABEL] (state, { id, label}) {
    if (state.currentReportTileGrid.tilegrid_json.areas[id.split("_")[0]]) {
      if ((id in state.currentReportTileGrid.tilegrid_json.areas[id.split("_")[0]])) {
        Vue.set(
          state.currentReportTileGrid.tilegrid_json.areas[id.split("_")[0]][id],
          "label",
          label
        )
      }
    }
  },
  [_ADD_AREA](state, { area }) {
    if (!state.currentReportTileGrid.tilegrid_json.areas[area.id.split("_")[0]]) {
      Vue.set(
        state.currentReportTileGrid.tilegrid_json.areas,
        area.id.split("_")[0],
        {}
      );
    }
    Vue.set(
      state.currentReportTileGrid.tilegrid_json.areas[area.id.split("_")[0]],
      area.id,
      area
    );
  },
  [_EDIT_AREA](state, { area }) {
    state.currentReportTileGrid.tilegrid_json.areas[area.area_class_id][
      area.id
    ].area = area.size;
    state.currentReportTileGrid.tilegrid_json.areas[area.area_class_id][
      area.id
    ].rate = area.ratio;
    state.currentReportTileGrid.tilegrid_json.areas[area.area_class_id][
      area.id
    ].suspicious = area.suspicious;
  },
  [_DELETE_AREA](state, { area }) {
    delete state.currentReportTileGrid.tilegrid_json.areas[area.area_class_id][
      area.id
    ];
    if (
      Object.keys(
        state.currentReportTileGrid.tilegrid_json.areas[area.area_class_id]
      ).length < 1
    ) {
      delete state.currentReportTileGrid.tilegrid_json.areas[
        area.area_class_id
      ];
    }
  },
  [_ADD_TILE](state, { tile }) {
    if (!state.currentReportTileGrid.tilegrid_json.tiles[tile.id]) {
      Vue.set(
        state.currentReportTileGrid.tilegrid_json.tiles,
        tile.id,
        {}
      );
    }
    Vue.set(
      state.currentReportTileGrid.tilegrid_json.tiles,
      tile.id,
      tile
    );
  },
  [_DELETE_TILE](state, { tile }) {
    delete state.currentReportTileGrid.tilegrid_json.tiles[tile.id];
  },
  [_SET_CURRENT_REPORTBATCH](state, { reportBatch }) {
    state.currentReportBatch = reportBatch;
  },
  [_SET_CURRENT_REPORTWSI](state, { reportWSI }) {
    state.currentReportWSI = reportWSI;
  },
  [_SET_CURRENT_REPORTTILEGRID](state, { reportTileGrid }) {
    state.currentReportTileGrid = reportTileGrid;
  },
  [_SET_CURRENT_REPORTDIAGNOSIS](state, { reportDiagnosis }) {
    state.currentReportDiagnosis = reportDiagnosis;
  },
  [_TOGGLE_LOADING_REPORTTILEGRID](state) {
    state.loadingReportTileGrid = !state.loadingReportTileGrid;
  },
  [_TOGGLE_LOADING_REPORTDIAGNOSIS](state) {
    state.loadingReportDiagnosis = !state.loadingReportDiagnosis;
  },
  [_REMOVE_SUSPICIOUS](state, { area_class_id, area_id }) {
    state.currentReportTileGrid.tilegrid_json.areas[area_class_id][
      area_id
    ].suspicious = false;
  },
  add: (state, item) => {
    if (state.allIds === undefined) {
      state.allIds = [];
    }
    for (let key of Object.keys(item)) {
      Vue.set(state.byId, key, item[key]);
      if (state.allIds.includes(key)) return;
      state.allIds.push(key);
      item[key].reportwsis.sort((a, b) => (a.last_updated < b.last_updated ? 1 : -1)).forEach(reportWSI => {
        let n = normalize(reportWSI, ReportWSI).entities.reportWSI
        // commit("addWSI", n.entities.reportWSI)
        if (state.allIdsReportWSI === undefined) {
          state.allIdsReportWSI = [];
        }
        for (let key of Object.keys(n)) {
          Vue.set(state.byIdReportWSI, key, n[key]);
          if (state.allIdsReportWSI.includes(key)) return;
          state.allIdsReportWSI.push(key);
        }
          })
    }
  },
  incrementCurrentReportWSIIndex: state => state.currentIndexReportWSI++,
  decreaseCurrentReportWSIIndex: state => state.currentIndexReportWSI--,
  setCached: (state, value) => (state.cached = value)
};

const actions = {
  async [_ACTION_REMOVE_SUSPICIOUS]({ commit }, { area_class_id, area_id }) {
    commit(_REMOVE_SUSPICIOUS, {
      area_class_id: area_class_id,
      area_id: area_id
    });
  },
  async [_ACTION_SET_LABEL]({ commit }, { id, label }) {
    commit(_SET_LABEL, { id: id, label: label});
  },
  async [_ACTION_ADD_AREA]({ commit }, { area }) {
    commit(_ADD_AREA, { area: area });
  },
  async [_ACTION_EDIT_AREA]({ commit }, { area }) {
    commit(_EDIT_AREA, { area: area });
  },
  async [_ACTION_DELETE_AREA]({ commit }, { area }) {
    commit(_DELETE_AREA, { area: area });
  },
  async [_ACTION_ADD_TILE]({ commit }, { tile }) {
    commit(_ADD_TILE, { tile: tile });
  },
  async [_ACTION_DELETE_TILE]({ commit }, { tile }) {
    commit(_DELETE_TILE, { tile: tile });
  },
  async [_LOAD_REPORTBATCHES]({ commit, rootGetters, state }, paging) {
    // if (state.cached) return;
    // commit(_SET_REPORTBATCHES, { wsis: [] });

    const reportBatches = await fetchReportBatches(rootGetters.token, paging);
    reportBatches.results.sort((a, b) => (a.last_updated < b.last_updated ? 1 : -1)).forEach(reportBatch => {
      let r = normalize(reportBatch, ReportBatch);
      commit("add", r.entities.reportBatch);
    });
    // commit(_SET_REPORTBATCHES, { ReportBatches })
    // commit("setCached", true);
  },
  async [_CREATE_REPORTBATCH]({ commit, rootGetters }, reportBatch) {
    const res = await createReportBatch(rootGetters.token, reportBatch);
    let r = normalize(res, ReportBatch);
    commit("add", r.entities.reportBatch);
  },
  async [_UPDATE_REPORT]({ commit, rootGetters }, reportTileGrid) {
    const res = await updateReportTileGrid(rootGetters.token, reportTileGrid);
    let r = normalize(res, ReportTileGrid);
    commit(_SET_CURRENT_REPORTTILEGRID, { reportTileGrid: res });
  },
  async [_ACTION_SET_CURRENT_REPORTWSI](
    { commit, state, rootGetters },
    { reportWSI, id }
  ) {
    let reportWSIRetrieved = reportWSI;
    if (!reportWSI) {
      reportWSIRetrieved = await fetchReportWSI(rootGetters.token, id);
      let r = normalize(reportWSIRetrieved, ReportWSI);
    } else {
      if (
        state.currentReportWSI &&
        state.currentReportWSI.id === reportWSI.id
      ) {
        return;
      }
    }
    commit(_SET_CURRENT_REPORTWSI, { reportWSI: reportWSIRetrieved });
  },
  async [_ACTION_SET_CURRENT_REPORTTILEGRID](
    { commit, state, rootGetters },
    { reportTileGrid, id }
  ) {
    commit(_TOGGLE_LOADING_REPORTTILEGRID);
    let reportTileGridRetrieved = reportTileGrid;
    if (!reportTileGrid) {
      reportTileGridRetrieved = await fetchReportTileGrid(
        rootGetters.token,
        id
      );
      let r = normalize(reportTileGridRetrieved, ReportTileGrid);
    } else {
      if (
        state.currentReportTileGrid &&
        state.currentReportTileGrid.id === reportTileGrid.id
      ) {
        commit(_TOGGLE_LOADING_REPORTTILEGRID);
        return;
      }
    }
    if (!reportTileGridRetrieved.tilegrid_json.areas["n"])
      reportTileGridRetrieved.tilegrid_json.areas["n"] = {};
    commit(_SET_CURRENT_REPORTTILEGRID, {
      reportTileGrid: reportTileGridRetrieved
    });
    commit(_TOGGLE_LOADING_REPORTTILEGRID);
  },
  async [_ACTION_SET_CURRENT_REPORTDIAGNOSIS](
    { commit, rootGetters, state },
    { reportDiagnosis, id }
  ) {
    commit(_TOGGLE_LOADING_REPORTDIAGNOSIS);
    let reportDiagnosisRetrieved = reportDiagnosis;
    if (!reportDiagnosis) {
      reportDiagnosisRetrieved = await fetchReportDiagnosis(
        rootGetters.token,
        id
      );
      let r = normalize(reportDiagnosisRetrieved, ReportDiagnosis);
    } else {
      if (
        state.currentReportDiagnosis &&
        state.currentReportDiagnosis.id === reportDiagnosis.id
      ) {
        return;
      }
    }
    commit(_SET_CURRENT_REPORTDIAGNOSIS, {
      reportDiagnosis: reportDiagnosisRetrieved
    });
    commit(_TOGGLE_LOADING_REPORTDIAGNOSIS);
  },
  [_REPORT_NEXT]({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.currentIndexReportWSI === state.allIdsReportWSI.length - 1) {
        reject();
        return;
      }
      commit("incrementCurrentReportWSIIndex");
      resolve();
    });
  },
  [_REPORT_PREVIOUS]({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.currentIndexReportWSI === 0) {
        reject();
        return;
      }
      commit("decreaseCurrentReportWSIIndex");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
